import React, { Fragment } from 'react';
import SpinnerDiv from "root/Forms/UI/SpinnerDiv";
import useListboxFetch from "./useListboxFetch";
import { CommonDropdown } from "./CommonDropdown";

const DropdownOrganisationTypes = ({ control, name, rules, placeholder, isSearchable, isClearable, isMulti, readOnly } ) =>
{
    const [ loading, items ] = useListboxFetch( { url: '/organisation/types', keyFieldName: 'organisation_type_id', labelFieldName: 'organisation_desc', additionalFields: [] } ) ;

    return (
        <Fragment>
            { loading === true && <div className='form-control'><SpinnerDiv/></div> }
            { loading === false && <CommonDropdown items={items} control={control} name={name} rules={rules} placeholder={placeholder} isSearchable={isSearchable} isClearable={isClearable} isMulti={isMulti} readOnly={readOnly} /> }
        </Fragment>
    )
}

export default DropdownOrganisationTypes;
